











































































































































import {Component, Prop, Vue} from 'vue-property-decorator';

import _ from 'lodash';
import numeral from 'numeral';

import {Getter} from 'vuex-class';
import { AUTH_GET_CLIENT } from '@/store/modules/authentication/types';

import {SaleTypeEnum} from '@/modules/neodash/model/types/enums/saleTypeEnum';
import {ITextValue} from '@/interfaces/key-value-interface';
import {BpaStatusReport, BpaStatusReportValues} from '@/modules/business-plan/modules/models/bpaStatusReport';
import { ClientEnum } from '@/enums/client.enum';
import { Client } from '@/store/modules/authentication/interfaces';

enum levelEnum {
  Regional = 1,
  InfluenceArea = 2,
  Group = 3
}

interface IState {
  selectedTarget: number,
  selectedSaleType: number,
  selectedFamilies: Array<number>,
  selectedArea: string,
  dataReport: Array<IStatusReport>,
}

interface ISection {
  level: levelEnum,
  key: string,
  content: string,
  action: (name: string) => IStatusReport[]
}

interface IStatusReport {
  name: string,
  qtdStores: number,
  valueIndustry: number,
  valueBusinessPlan: number,
  shareBusinessPlan: number,
  qtdStoresWithResponse: number,
  percentResponse: number,
  valueGoalDefined: number,
  valueGoalDefinedNegotiate: number,
  shareGoalDefined: number,
  difQtdStores: number,
  difValue: number,
  funcDown: (name: string) => IStatusReport[] | undefined;
  funcUp: (name: string) => IStatusReport[] | undefined;
}

class StatusReport implements IStatusReport {
  constructor(
      name: string,
      qtdStores: number,
      qtdStoresWithResponse: number,
      valueBusinessPlan: number,
      valueGoalDefined: number,
      valueGoalDefinedNegotiate: number,
      valueIndustry: number,
      funcDown: (name: string) => IStatusReport[] | any = () => {},
      funcUp: (name: string) => IStatusReport[] | any = () => {}) {
    this.name = name;
    this.qtdStores = qtdStores;
    this.qtdStoresWithResponse = qtdStoresWithResponse;
    this.valueBusinessPlan = valueBusinessPlan;
    this.valueGoalDefined = valueGoalDefined;
    this.valueGoalDefinedNegotiate = valueGoalDefinedNegotiate;
    this.valueIndustry = valueIndustry;

    this.funcDown = funcDown;
    this.funcUp = funcUp;
  }

  name: string;
  qtdStores: number;
  qtdStoresWithResponse: number;
  valueBusinessPlan: number;
  valueGoalDefined: number;
  valueGoalDefinedNegotiate: number;
  valueIndustry: number;

  funcDown: (name: string) => IStatusReport[] | undefined;
  funcUp: (name: string) => IStatusReport[] | undefined;

  public get shareBusinessPlan(): number {
    return this.valueBusinessPlan / this.valueIndustry;
  }

  public get percentResponse(): number {
    return this.qtdStoresWithResponse / this.qtdStores;
  }

  public get shareGoalDefined(): number {
    return this.valueGoalDefined / this.valueIndustry;
  }

  public get difQtdStores(): number {
    return this.qtdStoresWithResponse - this.qtdStores;
  }

  public get difValue(): number {
    return this.valueGoalDefined - this.valueBusinessPlan;
  }
}

@Component({
  name: 'GoalStatusReport'
})
export default class GoalStatusReport extends Vue {
  public numeral = numeral;
  public openPointName: string = 'OPEN POINT';
  public readonly clientEnum = ClientEnum;

  @Getter(AUTH_GET_CLIENT)
  public client: Client;

  @Prop({required: true})
  public opened: boolean;

  @Prop({required: true})
  public sourceFamily: ITextValue<number>[];

  @Prop({required: true})
  public data: Array<BpaStatusReport>;

  public sourceTarget: any = [];
  public sourceSaleType: any = [];
  public sourceSections: Array<ISection> = new Array<ISection>();

  public state = {
    selectedTarget: 1,
    selectedSaleType: 3,
    selectedFamilies: new Array<number>(),
    selectedArea: '',
    dataReport: new Array<IStatusReport>()
  }

  public setDataReport(data: IStatusReport[]) {
    this.state.dataReport = data;
  }

  public toggleStatusReportOpen() {
    this.$emit('toggleStatusReportOpen')
  }

  public getStylePercentResponse(value: number): string {
    if (value <= 0.7)
      return 'redCell';

    if (value > 0.7 && value <= 0.95)
      return 'yellowCell';

    if (value > 0.95)
      return 'greenCell';

    return '';
  }

  public addSection(level: levelEnum, key: string, content: string, action: (name: string) => IStatusReport[]) {
    this.sourceSections.push({ level: level, key: key, content: content, action: action } as ISection)
  }

  public removeSection(key: string,  content: string) {
    this.sourceSections = this.sourceSections.filter(x => x.key === key && x.content === content);
  }

  public applyFilter() {
    const action = {
      [levelEnum.Regional]: this.buildDataReport,
      [levelEnum.Group]: this.drillDownByAreaInfluence,
      [levelEnum.InfluenceArea]: this.drillDownByRegional
    }

    const crrLevel = _(this.sourceSections).last();
    this.setDataReport(crrLevel ? action[crrLevel.level](crrLevel.content) : action[levelEnum.Regional]());
  }

  public buildDataReport(): IStatusReport[] {
    const propToGroup = this.sourceTarget.findOrFirst(x => x.value === this.state.selectedTarget).key;
    let funcDown = this.drillDownByRegional;
    this.state.selectedArea = 'REGIONAL';
    this.sourceSections.length = 0;

    if (propToGroup === 'nameResponsible') {
      funcDown = this.drillDownByConsultant;
    }
    
    const data = _(this.data).groupBy((x: BpaStatusReport) => x[propToGroup]).value();
    return this.build(data, funcDown, this.buildDataReport);
  }

  public drillDownByRegional(regionalName: string): IStatusReport[] {
    const key = 'regional';
    const data = _(this.data)
        .filter(x => x.nameLocaleSuperior === regionalName && this.filterOpenPoint(x))
        .groupBy((x: BpaStatusReport) => x.nameLocale)
        .value();

    this.sourceSections.some(x => x.key === key && x.content === regionalName)
        ? this.removeSection(key, regionalName)
        : this.addSection(levelEnum.InfluenceArea, key, regionalName, this.buildDataReport);

    this.state.selectedArea = this.client.id === this.clientEnum.Ford ? 'AREA INFLUÊNCIA' : 'OPERATIONAL AREA';
    return this.build(data, this.drillDownByAreaInfluence, this.drillDownByRegional);
  }

  public drillDownByAreaInfluence(areaName: string): IStatusReport[] {
    this.state.selectedArea = this.client.id === this.clientEnum.Ford ? 'GRUPO' : 'GROUP';
    if (!this.sourceSections.some(x => x.key === this.sourceSections[0].content && x.content === areaName)) {
      this.addSection(levelEnum.Group, this.sourceSections.slice(-1)[0].content, areaName, this.drillDownByRegional);
    }

    const data = _(this.data).filter(x => x.nameLocale === areaName).groupBy((x: BpaStatusReport) => x.nameGroup).value();
    return this.build(data)
  }

  public drillDownByConsultant(name: string): IStatusReport[] {
    this.sourceSections.length = 0;
    this.addSection(levelEnum.InfluenceArea, 'consultant', name, this.buildDataReport);
    const data = _(this.data).filter(x => x.nameResponsible === name).groupBy((x: BpaStatusReport) => x.nameGroup).value();

    return this.build(data)
  }

  public get dataReportTotal(): IStatusReport {
    const valueIndustry = this.state.dataReport.sumBy(x => x.valueIndustry);
    const valueBusinessPlan = this.state.dataReport.sumBy(x => x.valueBusinessPlan);
    const valueGoalDefined = this.state.dataReport.sumBy(x => x.valueGoalDefined);
    const valueGoalDefinedNegotiate = this.state.dataReport.sumBy(x => x.valueGoalDefinedNegotiate);
    const qtdStore = this.state.dataReport.sumBy(x => x.qtdStores);
    const qtdStoreWithResponse = this.state.dataReport.sumBy(x => x.qtdStoresWithResponse);

    return new StatusReport('TOTAL', qtdStore, qtdStoreWithResponse, valueBusinessPlan, valueGoalDefined, valueGoalDefinedNegotiate, valueIndustry)
  }

  private build(
      source: any,
      funcDown: (name: string) => IStatusReport[] | any = () => {},
      funcUp: (name: string) => IStatusReport[] | any = () => {}): IStatusReport[] {
    const result = _(Object.entries(source))
        .map(([key, items]: [string, BpaStatusReport[]]) => {
          let valuesReport = _(items).map((x: BpaStatusReport) => x.values).flatten().value();

          if (this.state.selectedSaleType !== SaleTypeEnum.AllOfIt)
            valuesReport = valuesReport.filter(x => x.saleType === this.state.selectedSaleType);

          if (this.state.selectedFamilies.length)
            valuesReport = valuesReport.filter(x => this.state.selectedFamilies.includes(x.idFamily));
          else {
            valuesReport = valuesReport.filter(x => x.idFamily != 96)
          }

          const valueIndustry = valuesReport.sumBy(x => x.valueIndustry);
          const valueBusinessPlan = valuesReport.sumBy(x => x.valueBusinessPlan);
          const valueGoalDefined = valuesReport.sumBy(x => x.valueGoalDefined);
          const valueGoalDefinedNegotiate = valuesReport.sumBy(x => x.valueGoalDefinedNegotiate);
          const qtdStore = items.filter((x: BpaStatusReport) => this.filterOpenPoint(x)).length;
          const qtdStoreWithResponse = items.filter((x: BpaStatusReport) => this.filterOpenPoint(x) && x.isNegotiateConcluded).length;

          return new StatusReport(key, qtdStore, qtdStoreWithResponse, valueBusinessPlan, valueGoalDefined, valueGoalDefinedNegotiate, valueIndustry, funcDown, funcUp);
        })
        .value();

    // Crazy error of typescript.
    const temp = result as [];
    return Array.from<IStatusReport>(temp as IStatusReport[]);
  }

  private filterOpenPoint(item: BpaStatusReport) : boolean {
    return item.nameGroup.toUpperCase() !== this.openPointName.toUpperCase();
  }

  public mounted() {
    this.sourceTarget = [
      { text: 'Regional', value: 1, key: 'nameLocaleSuperior' },
      { text: (this.client.id === this.clientEnum.Ford ? 'Consultor' : 'Consultant'), value: 2, key: 'nameResponsible' },
    ];

    this.sourceSaleType = [
      {text: (this.client.id === this.clientEnum.Ford ? 'ROR' : 'Retail + Small Fleet'), value: SaleTypeEnum.RetailSales},
      {text: (this.client.id === this.clientEnum.Ford ? 'Direta' : 'Big Fleet'), value: SaleTypeEnum.DirectSales},
      {text: 'Total', value: SaleTypeEnum.AllOfIt},
    ];

    this.state.dataReport = this.buildDataReport();
  }
}

